<template>
  <section>
<!--    <m-table-list ref="tableList" :search-form.sync="filters">-->
    <m-table-list ref="tableList" :fetch-list-func="fetchListFunc" :search-form.sync="filters">
      <template v-slot:search-items>
        <m-search-panel @searchBoxChange="handleSearch" isShowOpenButton @keyup.enter.native="handleSearch()">
          <div slot="title">数据筛选</div>
          <div class="filters">
            <div class="query-item-all">
              <!-- <div class="filter-item">
                <div class="demonstration">输入查询</div>
                <el-input v-model="filters.userId" placeholder="用户ID/账号"></el-input>
              </div> -->
              <div class="filter-item">
                <div class="demonstration">UC账号</div>
                <el-input v-model="filters.userName" placeholder="用户账号名称"></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">账号状态</div>
                 <el-select v-model="filters.status" placeholder="--未选择--">
                    <el-option :value="null" label="不限"></el-option>
                    <el-option value="Enable" label="启用" />
                    <el-option value="Disable" label="禁用" />
                </el-select>
              </div>
            </div>
            <div class="filter-item buttons">
              <el-button type="primary" size="small" class="query-btn" @click="handleSearch">查询</el-button>
              <el-button type="primary" size="small" plain @click="handleClearSearchForm">重置</el-button>
            </div>
          </div>
        </m-search-panel>
      </template>
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column label="UC账号" prop="account"></el-table-column>
        <el-table-column label="电话" prop="phone"></el-table-column>
        <el-table-column label="真实姓名" prop="realName"></el-table-column>
        <el-table-column label="部门" prop="deptName" align="center"></el-table-column>
        <el-table-column label="所属角色" prop="role" align="center"></el-table-column>
        <el-table-column label="启用" prop="status" align="center">
            <template slot-scope="{row}">{{row.status == 'Enable' ? '是' :'否'}}</template>
        </el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="{row}">
            <el-button @click="$router.push({name: 'usermange.loginManage.logList', query: { id: row.userId }})" type="text"
                       size="small">查看登录日志
            </el-button>
          </template>
        </el-table-column>
      </template>
    </m-table-list>
  </section>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";

export default {
  name: "usermange.loginManage.userList",
  data() {
    return {
      filters: {
        userName: "",
        status:null
      },
      time: "",
    };
  },
  components: {
    "m-table-list": tableList,
  },
  created() {
  },
  methods: {
    fetchListFunc: api.log.getUserInfoList,
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.$refs.tableList.resetSearchForm();
    },
    // fetchListFunc() {},
    deleteRow(id) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass:'confirmBtn',
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.manage.deleteMenu({id}).then(() => {
          this.$message.success("删除成功");
          this.$refs.tableList.getMainData();
        });
      });
    },
    handleUserStatusChange(status, row, index) {
      return api.manage.updateUserStatus({userId: row.userId})
          .then(res => {
            this.$message.success('提交成功');
            this.$refs.tableList.setRowValue(index, {status})
          })
    }
  },
};
</script>
